import React from 'react';
import AdminSideMenu from '../../components/AdminSideMenu';
import SpecialPackageCard from '../../components/SpecialPackageCard';

const SpecialPackageAdmin = () => {
    return (
        <div className='flex flex-col md:flex-row min-h-screen bg-gray-50'>
            {/* LEFT SIDE → Sidebar */}
            <AdminSideMenu />

            {/* RIGHT SIDE → Content */}
            <div className='w-full md:ml-64 p-4 sm:p-6 lg:p-8'>
                {/* Header (same style as Packages page) */}
                <header className='mb-8'>
                    <div className='flex flex-col md:flex-row md:items-center md:justify-between gap-4'>
                        <div>
                            <h1 className='text-3xl font-bold text-gray-900'>Special Package</h1>
                            <p className='text-gray-600'>Manage exclusive package for carriers.</p>
                        </div>
                    </div>
                </header>

                {/* Card Section (same grid feel) */}
                <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 md:grid-cols-1 gap-8 items-stretch'>
                    {/* Single Special Package Card */}
                    <div className='flex justify-center md:justify-start'>
                        <SpecialPackageCard isAdmin={true} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SpecialPackageAdmin;
